import {formatter, request} from '@/utils/request';

export namespace ProductPrice {
  export const Path = {
    GetProductPrice: '/expenseapi/productPrice/getProductPrice',
    getSoldToPriceSellin1: '/expenseapi/productPrice/getSoldToPriceSellin1',
    getSoldToPriceSellin2: '/expenseapi/productPrice/getSoldToPriceSellin2',
    getRegionPriceSellin1: '/expenseapi/productPrice/getRegionPriceSellin1',
    getRegionPriceSellin2: '/expenseapi/productPrice/getRegionPriceSellin2',
    getRegionPriceLimit: '/expenseapi/productPrice/getRegionPriceLimit',
    getProductPriceFg: '/expenseapi/productPrice/getProductPriceFg',
    getCrmTj: '/expenseapi/productPrice/getCrmTj',
  };

  export async function getProductPrice(body: API.ProductPriceSearchParam) {
    if (REACT_APP_ENV == 'dev' || REACT_APP_ENV == 'test') {
      if (!body || !body.productId) {
        alert("只在开发测试环境出现的提示: 参数为空, 禁止调用后端接口, 调用逻辑需处理! 参数productId:" + body.productId);
      }
    }
    const options = {
      method: 'GET',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.PriceResult>>(Path.GetProductPrice, formatter(options));
  }

  export async function getSoldToPriceSellin1(body: API.PriceSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.PriceResult>>(Path.getSoldToPriceSellin1, formatter(options));
  }

  export async function getCrmTj(body: API.PriceSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.PriceResult>>(Path.getCrmTj, formatter(options));
  }

  export async function getSoldToPriceSellin2(body: API.PriceSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.PriceResult>>(Path.getSoldToPriceSellin2, formatter(options));
  }

  export async function getRegionPriceSellin1(body: API.PriceSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.PriceResult>>(Path.getRegionPriceSellin1, formatter(options));
  }

  export async function getRegionPriceSellin2(body: API.PriceSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.PriceResult>>(Path.getRegionPriceSellin2, formatter(options));
  }

  export async function getRegionPriceLimit(body: API.PriceSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.PriceResult>>(Path.getRegionPriceLimit, formatter(options));
  }

  export async function getProductPriceFg(body: API.PriceSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.PriceResult>>(Path.getProductPriceFg, formatter(options));
  }
}
